import React, {Component} from "react";
import {connect} from 'react-redux';
import {updateDigitalZoomStatus} from "../../../redux_actions/maps.state.action";
import {BottomNavigation, BottomNavigationAction, IconButton, Stack} from "@mui/material";
import {ZoomIn, ZoomOut} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    checkIfDigitalZoom,
    decrementZoomLevel,
    getMaxZoomFor,
    getZoomLevel,
    ifShowDigitalText,
    incrementZoomLevel
} from "../utils/zoomControlUtils";
import {Loading} from "../components/components";
import {checkAbstractAppPermission, defaultDigitalZoomOn} from "component/utils/abstract_app_maker";
import ZoomBarOSD from "./ZoomBarOSD";

class ZoomControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openPanel: false,
        }
    }

    componentDidMount () {
        if (!this.props.slidemap?.getView()) return
        const digitalZoomStatus = checkAbstractAppPermission(defaultDigitalZoomOn)

        this.props.slidemap.getView().setMaxZoom(
            getMaxZoomFor(this.props.zoomLevels, digitalZoomStatus, this.props.nativeTopLevel));
        
        this.props.dispatch(updateDigitalZoomStatus(this.props.activeMapId, digitalZoomStatus));
    }

    toggleDigitalZoom = () => {
        this.props.slidemap.getView().setMaxZoom(
            getMaxZoomFor(this.props.zoomLevels, !this.props.digitalZoomStatus, this.props.nativeTopLevel));
        this.props.dispatch(updateDigitalZoomStatus(this.props.activeMapId, !this.props.digitalZoomStatus));
    }

    getIntegerZoomLevel = () => {
        let zoomFloor = parseInt(Math.floor(this.props.z));
        let zoomMantissa = this.props.z - zoomFloor;
        let zoomCeil = parseInt(Math.ceil(this.props.z));
        let actualZoomValue = (this.props.zoomScale[zoomFloor] + (zoomMantissa * (this.props.zoomScale[zoomCeil] -
            this.props.zoomScale[zoomFloor])));
        return Number.isInteger(actualZoomValue) ? parseInt(actualZoomValue) : Math.round(actualZoomValue * 100) / 100;
    }

    render() {

        if (!this.props.slidemap) return <Loading/>;
        if (this.props.slidemap._isOpenSeadragon) return <ZoomBarOSD/>;
        // OpenSeadragon zooms continuously, so z can fall between levels.
        let actualZoomValueTiled = this.getIntegerZoomLevel();
        let actualZoomValue = Number.isInteger(this.props.z) ?
            getZoomLevel(this.props.zoomScale, this.props.z) : actualZoomValueTiled;
        let levelZ = Math.round(this.props.z);

        let isDigital = checkIfDigitalZoom(this.props.zoomLevels, levelZ, this.props.nativeTopLevel);

        let showDigitalText =
            ifShowDigitalText(this.props.zoomLevels, levelZ, this.props.digitalZoomStatus, this.props.nativeTopLevel);


        let zoomOverlayComponent;
        if (this.state.openPanel) {
            zoomOverlayComponent = <Box sx={{
                height: '200px', width: '80px', border: '0px', bgcolor: "rgba(51, 4, 112,0.8)", display: "flex"
            }}>
			    <Typography sx={{width: '100%'}}>
                    <Stack direction="column" justifyContent={"space-around"} marginTop={1}
                           marginBottom={1} sx={{height: '180px'}}>
                        {showDigitalText ?
                            <IconButton
                                onClick={this.toggleDigitalZoom}
                                sx={{height: '80px', fontSize: '15px', color: '#00f548'}}
                            >
                                <Typography sx={{fontSize: '15px'}}>
                                    {this.props.digitalZoomStatus ? "Disable" : "Enable"}
                                    <br/>
                                    Digital
                                    <br/>
                                    Zoom
                                </Typography>
                            </IconButton> :
                            <IconButton
                                onClick={() => incrementZoomLevel(this.props.slidemap.getView(), this.props.z)}
                                sx={{height: '80px', color: '#00f548'}}
                            >
                                <ZoomIn fontSize="large"/>
                            </IconButton>
                        }
                        <IconButton
                            onClick={() => decrementZoomLevel(this.props.slidemap.getView(), this.props.z)}
                            sx={{height: '80px', color: '#00f548'}}
                        >
                            <ZoomOut fontSize="large"/>
                        </IconButton>
                    </Stack>
                </Typography>
            </Box>
        }

        let textColor;
        textColor = isDigital ? "#ed6111" : this.state.openPanel ? "#00f548" : "white";

        return (
            <Stack direction="column-reverse" justifyContent={"flex-end"} className="zoomControl-forTour">
                <BottomNavigation sx={{borderRadius: 0, bgcolor: "rgba(51, 4, 112,0.8)", width: "80px"}}
                                  value={this.state.app}
                                  onChange={() => this.setState({openPanel: !this.state.openPanel,})}>
                    <BottomNavigationAction icon={<>
                        <Typography variant={'h5'} align={"center"} gutterBottom={!isDigital}
                                    color={textColor}>
                            {this.props.tileMapEnable ? actualZoomValueTiled : actualZoomValue}X
                        </Typography>
                        {isDigital ?
                            <Typography marginBottom={1} variant="caption" align={"center"} color={textColor}>
                                Digital
                            </Typography> : null}
                    </>}/>
                </BottomNavigation>
                {zoomOverlayComponent}
            </Stack>
        )
    }
}

const mapStateToProps = (state) => {
    let activeMapId = state.gammaStateReducer.activeMapId;
    let tileMapEnable = state.gammaStateReducer.tileMapEnable;
    let {zoomScale, maxZoom, z, digitalZoomStatus, zoomLevels, slidemap, nativeTopLevel} = state.mapsStateReducer[activeMapId] ?? {};
    return {activeMapId, zoomScale, maxZoom, z, digitalZoomStatus, tileMapEnable, zoomLevels, slidemap, nativeTopLevel};
}

export default connect(mapStateToProps)(ZoomControl);
